exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cryptoTitle[data-v-e0340278] {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 2rem;\n    letter-spacing: 0.0125em !important;\n}\n\n", ""]);
